import i18next from 'i18next';
import * as Yup from 'yup';

export const securityCodeValidationSchema = Yup.object().shape({
  SecurityCode: Yup.string()
    .min(6, i18next.t('validationSchema.general.securityCodeRequired'))
    .max(6, i18next.t('validationSchema.general.securityCodeRequired'))
    .required(i18next.t('validationSchema.general.securityCodeRequired')),
});
